import axios from 'axios';

const API_CARTORIO_KEY = import.meta.env.VITE_API_CARTORIO_KEY;
const VITE_API_CARTORIO_URL = import.meta.env.VITE_API_CARTORIO_URL;

const axiosCartorio = axios.create({
  baseURL: VITE_API_CARTORIO_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const removerAcentos = (texto = '') =>
  texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

async function realizarBusca(estado, cidade) {
  const url = `/cartorios/geolocalizacao?estado=${encodeURIComponent(
    estado
  )}&cidade=${encodeURIComponent(
    cidade
  )}&apikey=${API_CARTORIO_KEY}&nao_mostrar_cartorio_recolhido=true`;

  const response = await axiosCartorio.post(url);
  return response.data;
}

const manterCidadeOriginal = (cartorios, cidadeOriginal) => {
  if (!Array.isArray(cartorios)) return cartorios;

  return cartorios.map((cartorio) => ({
    ...cartorio,
    cidade: cidadeOriginal,
  }));
};

export async function buscarCartoriosPorGeolocalizacao(estado, cidade) {
  if (!estado || !cidade) return [];

  try {
    const resultadoOriginal = await realizarBusca(estado, cidade);

    if (Array.isArray(resultadoOriginal) && resultadoOriginal.length > 0) {
      return resultadoOriginal;
    }

    const cidadeSemAcento = removerAcentos(cidade);

    if (cidadeSemAcento !== cidade) {
      const resultadoFallback = await realizarBusca(estado, cidadeSemAcento);

      if (Array.isArray(resultadoFallback) && resultadoFallback.length > 0) {
        return manterCidadeOriginal(resultadoFallback, cidade);
      }
    }

    return resultadoOriginal;
  } catch (error) {
    console.error(
      'Erro ao buscar cartórios por geolocalização:',
      error?.response?.data || error
    );

    throw new Error('Erro ao buscar cartórios');
  }
}

export async function buscarCartoriosPorCep(cep) {
  if (!cep) return [];

  const url = `/cartorios/geolocalizacao?CEP=${cep}&apikey=${API_CARTORIO_KEY}&nao_mostrar_cartorio_recolhido=true`;

  try {
    const response = await axiosCartorio.post(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar cartórios por CEP:', error);
    throw new Error('Erro ao buscar cartórios');
  }
}

export async function buscarCartorioPorCNS(cns) {
  if (!cns) {
    throw new Error('CNS não informado');
  }

  const url = `/cartorios/geolocalizacao?cns=${cns}&apikey=${API_CARTORIO_KEY}&nao_mostrar_cartorio_recolhido=true`;

  try {
    const response = await axiosCartorio.post(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar cartório por CNS:', error);
    throw new Error('Erro ao buscar cartório por CNS');
  }
}
